import {
  ActionSheet,
  Breadcrumbs,
  Button,
  Card,
  Container,
  List,
  Section,
  Stack,
  useActionSheetProvider,
} from "@storoey/sui";
import { createFileRoute, useNavigate } from "@tanstack/solid-router";
import { For, onMount } from "solid-js";
import { backendService } from "../../../backend/backend.service";
import { useNavbar } from "../../../contexts/RootContext";

export const Route = createFileRoute("/history/$formId/")({
  component: RouteComponent,
});

function RouteComponent() {
  const loaderData = Route.parentRoute.useLoaderData();
  const actionsheet = useActionSheetProvider();

  const { setTitle } = useNavbar();
  const navigate = useNavigate();

  onMount(() => {
    setTitle(loaderData().form.templateName);
  });

  const handleDelete = async () => {
    await backendService.deleteForm(loaderData().formId);

    navigate({ to: "/history" });
  };

  return (
    <>
      <Section
        padding="lg"
        breadcrumbs={
          <Container>
            <Breadcrumbs>
              <Breadcrumbs.Item onClick={() => navigate({ to: `/` })}>
                Hjem
              </Breadcrumbs.Item>
              <Breadcrumbs.Item onClick={() => navigate({ to: `/history` })}>
                Historie
              </Breadcrumbs.Item>
              <Breadcrumbs.Item current>
                {loaderData().form.templateName}
              </Breadcrumbs.Item>
            </Breadcrumbs>
          </Container>
        }
      >
        <Container>
          <Stack>
            <Card elevation={200}>
              <Card.Content>
                <Card.Title>{loaderData().form.templateName}</Card.Title>
                <Card.Text>
                  Opprettet:{" "}
                  {Intl.DateTimeFormat("no-NB", {
                    dateStyle: "medium",
                    timeStyle: "medium",
                  }).format(loaderData().form.createdAt)}
                </Card.Text>
                <Card.Text>
                  Endret:{" "}
                  {Intl.DateTimeFormat("no-NB", {
                    dateStyle: "medium",
                    timeStyle: "medium",
                  }).format(loaderData().form.updatedAt)}
                </Card.Text>
              </Card.Content>
              <Card.Actions>
                <List>
                  <For each={loaderData().categories}>
                    {(category) => (
                      <List.Item
                        trailingIcon="chevron_right"
                        trailingText={`${category.sectionCount}`}
                        onClick={() =>
                          navigate({
                            to: `./${category.id}`,
                          })
                        }
                      >
                        {category.title}
                      </List.Item>
                    )}
                  </For>
                </List>
              </Card.Actions>
            </Card>
            <Button variant="ghost" color="red" onClick={actionsheet.open}>
              Slett
            </Button>
          </Stack>
        </Container>
        <ActionSheet isOpen={actionsheet.isOpen} close={actionsheet.close}>
          <ActionSheet.Content
            title="Er du sikker?"
            text="Denne handlingen kan ikke reverseres."
          >
            <ActionSheet.Button onClick={handleDelete} danger>
              Slett
            </ActionSheet.Button>
          </ActionSheet.Content>
        </ActionSheet>
      </Section>
    </>
  );
}
